import axios from "axios";
import React, { useState } from "react";
import urls from "../../urls";
import { showError, showSuccess } from "../../utils";

const ChangeUserPassword = ({ onCancel, uuid }) => {
  // State for password field
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // Validate password input
  const validatePassword = () => {
    if (!password.trim()) {
      setError("كلمة المرور مطلوبة");
      return false;
    } else if (password.length < 8) {
      setError("كلمة المرور يجب أن تكون على الأقل 8 أحرف");
      return false;
    }
    setError("");
    return true;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validatePassword()) {
      handlePasswordChange(password);
    }
  };

  // Empty function for password change
  const handlePasswordChange = (password) => {
    console.log("Changing password to:", password);
    // Add server-side logic here later
    axios
      .post(urls.changePswd, {
        uuid,
        password,
      })
      .then((res) => {
        showSuccess("تم تغيير كلمة المرور بنجاح");
      })
      .catch((err) => {
        showError("لم يتم تغيير كلمة المرور بنجاح ");
        console.error(err);
      });
    console.log(uuid);
    onCancel();
  };

  // Handle cancel button click
  const handleCancel = () => {
    if (onCancel) {
      onCancel(); // Trigger the onCancel function from the parent
    }
  };

  return (
    <div className="container  ">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <form onSubmit={handleSubmit} noValidate>
            <div className="input-group ">
              {/* Password Input */}
              <div className="form-floating flex-grow-1">
                <input
                  type="password"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id="password"
                  placeholder="كلمة المرور الجديدة"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <label htmlFor="password">كلمة المرور الجديدة</label>
              </div>

              {/* Confirm Button */}
              <button type="submit" className="btn btn-primary">
                تأكيد
              </button>

              {/* Cancel Button */}
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                إلغاء
              </button>
            </div>

            {/* Error Message */}
            {error && <div className="text-danger">{error}</div>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangeUserPassword;
